const CELLS = [
  ["approved_points", "Approved", "text-white"],
  ["pending_points", "Pending", "text-amber-200"],
  ["submitted_points", "Submitted", "text-white/80"],
  ["rejected_points", "Rejected", "text-red-200"],
];

export const PointTotals = ({ profile }) => (
  <div className="grid grid-cols-4 gap-2 mt-3" data-testid="vol-point-totals">
    {CELLS.map(([k, label, cls]) => (
      <div key={k} className="rounded-xl bg-white/10 px-3 py-2">
        <div className="text-[9px] uppercase tracking-widest text-white/60 font-black">{label}</div>
        <div className={`text-lg font-black tabular-nums ${cls}`} data-testid={`vol-total-${k}`}>{profile[k] || 0}</div>
      </div>
    ))}
  </div>
);
